exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".connectbox{outline:0;text-decoration:none}.connectbox img{height:40px;transform:scale(1);transition:all .3s}.connectbox.toosmall img,.connectbox:hover img{transform:scale(1.3)}.connectbox.toosmall:hover img{transform:scale(1.6)}.connectbox span{transition:all .3s;opacity:1;z-index:1}.connectbox:hover span{opacity:0}.dasw{height:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.heightbox{min-height:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0090bbb4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/content/home-page.vue
// module id = 388
// module chunks = 0